import { render, staticRenderFns } from "./StaffChanges.vue?vue&type=template&id=4153b3a8&scoped=true&"
import script from "./StaffChanges.vue?vue&type=script&lang=js&"
export * from "./StaffChanges.vue?vue&type=script&lang=js&"
import style0 from "./StaffChanges.vue?vue&type=style&index=0&id=4153b3a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4153b3a8",
  null
  
)

export default component.exports